import { render } from "./PlayState.vue?vue&type=template&id=769e6b47"
import script from "./PlayState.vue?vue&type=script&lang=js"
export * from "./PlayState.vue?vue&type=script&lang=js"
script.render = render

export default script